import { FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminService } from './../../_services/admin.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ability-show',
  templateUrl: './ability-show.component.html',
  styleUrls: ['./ability-show.component.css']
})
export class AbilityShowComponent implements OnInit {

  breakSavePath="/admin/abilities"
  ability: undefined
  loading=false
  server_ability_id=0
  requiredAbilities=[]
  isSaving=false
  errorSaving=false
  searchAbilityForm:FormGroup
  abilitySearchList=[]
  constructor(private adminService:AdminService, private router:Router, private activatedRoute:ActivatedRoute) { }

  ngOnInit(): void {
    this.loadRequiredAbility()
    this.searchAbilityForm= new FormGroup(
      {'searchInput': new FormControl('')}
      )
      this.onSearchFormChanges()
  }


  onSearchFormChanges(): void {
    if(this.searchAbilityForm!=null){
      this.searchAbilityForm.get('searchInput').valueChanges.subscribe(val => {
        if(val.length>2){
          let data = new URLSearchParams();
          data.set('id',this.server_ability_id.toString())
          data.set('q', val.toString());
          this.adminService.searchAbilityToAddToAbility(data.toString(),this.server_ability_id).subscribe(
            dataData=>{
              this.abilitySearchList=dataData

            }
          )
      }else{
        this.abilitySearchList=[]
      }
    })
    }

}


loadRequiredAbility(){
  this.loading=true
  this.activatedRoute.params.subscribe(
    paramsIn=>{
      this.server_ability_id=paramsIn['server_ability_id']
      if(this.server_ability_id!=0){
        this.adminService.getAbility(this.server_ability_id).subscribe(
          abilityIn=>{
            this.ability= abilityIn
            this.requiredAbilities=abilityIn['requiredAbilities']
            this.loading=false
          }
        )
      }
    }
  )
}

addAbilityToAbility(ability_id:number){
  let dd = this.formatDataAddAbilityToAbility(ability_id)
  this.adminService.addAbilityToAbility(dd,this.server_ability_id).subscribe(
    dataData=>{
      this.requiredAbilities=dataData['requiredAbilities']
      this.removeAbilityFromSearchList(ability_id)
    }
  )
}

removeAbilityFromAbility(ability_id:number){
  let dd = this.formatDataAddAbilityToAbility(ability_id)
  this.adminService.removeAbilityFromAbility(dd,this.server_ability_id).subscribe(
    dataData=>{
      this.requiredAbilities=dataData['requiredAbilities']

    }
  )
}


 locateAbility(server_ability_id:number, searchAbilityResultList:any){
  let myS=undefined
  for( let i =0; i < searchAbilityResultList.length;i++){
    let aa = searchAbilityResultList[i]
    if(server_ability_id == aa['server_ability_id']){
      myS=searchAbilityResultList[i]
      break
  }
}
return myS
}


removeAbilityFromSearchList(server_subtopic_id:number){
  let index=0
  for( let i =0; i < this.abilitySearchList.length;i++){
    if(server_subtopic_id == this.abilitySearchList[i].id){
      index=i
      this.abilitySearchList.splice(index,1)
      break
  }
}
}

evaluateId(myList:Array<any>){
  let iid:Array<any>=[]
  for( let i =0; i < myList.length;i++){
    let aa =myList[i]
    if(aa){
      iid.push(aa['server_ability_id'])
    }

  }
  return iid
}
locateByIdInSearchList(server_ability_id:number){
  let myS:any=undefined
  for( let i =0; i < this.abilitySearchList.length;i++){
    if(server_ability_id == this.abilitySearchList[i].id){
      myS=this.abilitySearchList[i]
      break
  }
}
return myS
}
formatDataAddAbilityToAbility(ability_id:number){
  let data = new URLSearchParams();
  data.set('id',this.server_ability_id.toString())
  data.set('ability_id', ability_id.toString());

  return data.toString()
}
}
